var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable no-underscore-dangle */
import { Component, Vue } from 'vue-property-decorator';
import cloneDeep from "lodash-es/cloneDeep";
import { compPathToSourcePath, getLayoutFromPagelet, sourcePathToCompPath } from "../../../../lib/utils/layout";
import { highlightRect } from "../../../../lib/utils/browser/highlightRect";
import { getVNodeFactoryState } from "../../../../lib/renderer/utils";
import { writeClipboard } from "../../../../lib/utils";
import { concatStorageKey } from "../../../../lib/utils/vue/vueLinkLocalStorage";
let bus = null;
let initOpts = {
  editOption: 'json',
  showActions: true,
  recording: false,
  darkMode: false,
  capturing: false,
  open: false,
  displayMode: 'seperate'
};
/**
 * getDTBus返回一个当前dt设置, 外面可以直接修改返回的对象来改变dt的设置
 */
export const getDtOption = function () {
  var _bus;
  return ((_bus = bus) === null || _bus === void 0 ? void 0 : _bus.options) || {};
};
export const getDtBus = (opts = {}) => {
  initOpts = {
    ...initOpts,
    ...opts
  };
  if (bus) {
    Object.keys(opts).forEach(key => {
      bus.$set(bus.options, `${key}`, opts[key]);
    });
    return bus;
  }
  bus = new Vue({
    created() {
      Object.keys(opts).forEach(key => {
        this.$set(this.options, `${key}`, opts[key]);
      });
      this.$watch(() => this.activeCompInfo.compPath, val => {
        if (val === this.ucBus.designer) return;
        if (this.ucBus.designer) {
          this.ucBus.designer.compPath = val;
        }
      });
      this.$watch(() => {
        var _this$ucBus;
        return (_this$ucBus = this.ucBus) === null || _this$ucBus === void 0 || (_this$ucBus = _this$ucBus.designer) === null || _this$ucBus === void 0 ? void 0 : _this$ucBus.compPath;
      }, val => {
        if (!val || val === this.activeCompInfo.compPath) return;
        this.activeCompInfo.compPath = val;
      });
    },
    data() {
      return {
        reporter: null,
        extensionPanels: {},
        ucBus: {},
        parentEl: null,
        layoutOpts: {
          compSearchInput: '',
          searchInput: '',
          searchCandidates: [],
          candidateIndex: -1,
          dragInfo: {
            fromPath: null,
            toPath: null,
            prevPath: null
          },
          expandedLUT: {
            '': true
          },
          dataSourceDrawerOpen: '' // 数据源抽屉是否打开，字符串
        },
        timelineOpts: {
          events: [],
          selectedEvents: [],
          manualDisable: false
        },
        options: initOpts,
        activeCompInfo: {
          compPath: ''
        },
        windowRef: null,
        textarea: null,
        devToolTabKey: 'layout',
        // 这里没有直接用designer的scopeStack, 因为运行模式下也要用, dt自己维护一个
        scopedSlotStack: [],
        devTool: null,
        windowOptions: {
          width: '900',
          height: '600',
          left: '200',
          top: '200'
        },
        container: null
      };
    },
    methods: {
      beginListening() {
        this.$on('DevToolEventSpy', payload => {
          if (this.options.recording) {
            // 因为事件注册时在准备阶段绑定的，组件实例需要等实例化后才能获取到，所以这里需要重新获取一下
            const {
              compPath,
              renderer
            } = payload;
            this.timelineOpts.events = [...this.timelineOpts.events, {
              ...payload,
              compInstance: payload.compInstance || renderer.getRefByPath(compPath)
            }];
          }
        });
      },
      cleanBus() {
        var _initOpts, _initOpts2;
        this.options.recording = !!((_initOpts = initOpts) !== null && _initOpts !== void 0 && _initOpts.recording);
        this.devToolTabKey = 'layout';
        if (!((_initOpts2 = initOpts) !== null && _initOpts2 !== void 0 && _initOpts2.recording)) {
          this.timelineOpts.events = [];
          this.$off('DevToolEventSpy');
        }
        this.parentEl = null;
      },
      changeUc(uc) {
        this.ucBus = uc;
        // this.timelineOpts = {
        //   events: [] as Array<EventInfo>,
        //   selectedEvents: [] as Array<string>,
        //   manualDisable: false,
        // };
      }
    }
  });
  Object.keys(opts).forEach(key => {
    bus.$set(bus.options, `${key}`, opts[key]);
  });
  return bus;
};
export const freeDtBus = () => bus = null;
export const lsKeysForDevTool = {
  DS_PANEL_HEIGHT: concatStorageKey('dataDrawer', 'dataSourceDrawerHeight')
};
let devToolMixin = class devToolMixin extends Vue {
  messageOnDt(content) {
    this.$message.config({
      getContainer: () => {
        var _this$windowRef;
        return ((_this$windowRef = this.windowRef) === null || _this$windowRef === void 0 ? void 0 : _this$windowRef.document.body) || document.body;
      }
    });
    this.$message.success({
      content
    });
    this.$message.config({
      getContainer: () => document.body
    });
  }
  /**
   * 给出父renderer, 当前slot的容器路径，和当前的renderer，返回一个给dt的scopeStack用的对象
   * @param parentRenderer
   * @param prevCompPath
   * @param targetRenderer
   */
  findScopeInfo(parentRenderer, prevCompPath, targetRenderer) {
    const factoryState = getVNodeFactoryState(parentRenderer, prevCompPath);
    const parentLayout = getLayoutFromPagelet(parentRenderer.ucPagelet, prevCompPath);
    let scopedSlots = [];
    if (parentLayout !== null && parentLayout !== void 0 && parentLayout.scopedSlots) {
      scopedSlots = Object.entries(parentLayout === null || parentLayout === void 0 ? void 0 : parentLayout.scopedSlots).map(([key, value]) => ({
        type: key,
        layout: value.layout
      }));
    }
    let res;
    // 反向推导
    // eslint-disable-next-line array-callback-return
    scopedSlots.some(slot => {
      let index = -1;
      let type;
      const list = factoryState === null || factoryState === void 0 ? void 0 : factoryState.getScopedSlotInstances(slot.type);
      const found = list === null || list === void 0 ? void 0 : list.find((renderer, i) => {
        if (targetRenderer === renderer) {
          index = i;
          type = slot.type;
          return true;
        }
        return false;
      });
      if (found) {
        res = {
          index,
          list,
          type,
          compPath: prevCompPath
        };
      }
    });
    return res;
  }
  // ******** 对当前Layout的一些操作 **********
  dtHightLightRect(instance) {
    if (!this.bus.options.open || this.isDesignMode) return;
    if (!!instance) {
      var _instance$$el;
      highlightRect(instance === null || instance === void 0 ? void 0 : instance.$el.getBoundingClientRect(), 500, 'rgba(66,185,131, 0.5)', '#f0f0f0');
      instance === null || instance === void 0 || (_instance$$el = instance.$el) === null || _instance$$el === void 0 || _instance$$el.scrollIntoView();
    } else {
      var _getRef, _this$currentScope, _this$currentScope2;
      const el = (_getRef = (((_this$currentScope = this.currentScope) === null || _this$currentScope === void 0 || (_this$currentScope = _this$currentScope.list) === null || _this$currentScope === void 0 ? void 0 : _this$currentScope[(_this$currentScope2 = this.currentScope) === null || _this$currentScope2 === void 0 ? void 0 : _this$currentScope2.index]) || this.uc.renderer).getRef(this.activeCompPath)) === null || _getRef === void 0 ? void 0 : _getRef.$el;
      el.scrollIntoView();
      highlightRect(el === null || el === void 0 ? void 0 : el.getBoundingClientRect(), 500, 'rgba(66,185,131, 0.5)', '#f0f0f0');
    }
  }
  handleInsertComp(layout) {
    if (!layout) return;
    if (!this.activeCompPath) {
      var _this$designer;
      // appendChild
      (_this$designer = this.designer) === null || _this$designer === void 0 || _this$designer.spliceComp([], `${this.activeCompPath}/default/0`, layout);
    } else {
      var _this$designer2;
      // insert Before
      const pathArr = this.activeCompPath.split('/');
      if (pathArr.length <= 2) return;
      const index = +(pathArr.pop() || NaN);
      if (isNaN(index)) return;
      let newIndex = 0;
      if (index > 0) {
        newIndex = index - 1;
      }
      const newPath = `${pathArr.join('/')}/${newIndex}`;
      (_this$designer2 = this.designer) === null || _this$designer2 === void 0 || _this$designer2.spliceComp([], newPath, layout);
      this.$nextTick(() => {
        this.activeCompPath = newPath;
      });
    }
  }
  handleCopy(value) {
    // 不再一个document下的东西竟然focus不回去...;
    if (this.displayMode !== 'seperate') {
      writeClipboard(JSON.stringify(this.activeLayout, null, 2));
      return;
    }
    if (!this.windowRef) return;
    const focus1 = this.windowRef.document.activeElement;
    const newParent = focus1 !== null && focus1 !== void 0 && focus1.hasChildNodes() ? focus1 : focus1 === null || focus1 === void 0 ? void 0 : focus1.parentElement;
    newParent === null || newParent === void 0 || newParent.appendChild(this.bus.textarea);
    setTimeout(() => {
      if (this.bus.textarea.parentElement === newParent) {
        document.body.appendChild(this.bus.textarea);
        focus1.focus();
      }
    }, 50);
    if (!this.bus.textarea) return;
    this.bus.textarea.value = JSON.stringify(value, null, 2);
    this.bus.textarea.select();
    this.windowRef.document.execCommand('copy');
  }
  handleCopyActive() {
    this.handleCopy(this.activeLayout);
  }
  handleDeleteActive() {
    var _this$designer3;
    if (this.designer) (_this$designer3 = this.designer) === null || _this$designer3 === void 0 || _this$designer3.deleteActiveComp();
  }
  // ******** 选中隔壁组件，方向键 **********
  async selectPrev() {
    const {
      compPath
    } = this.bus.activeCompInfo;
    const pathArr = compPath.split('/');
    const len = pathArr.length;
    if (len <= 1) return;
    const index = pathArr[len - 1];
    const selectParentPrev = () => {
      const newCompPath = `${pathArr.slice(0, len - 2).join('/')}`;
      this.activeCompPath = newCompPath;
    };
    if (index === '0') {
      // slot的情况
      const {
        slotSiblings
      } = this.bus.activeCompInfo;
      if (slotSiblings.length) {
        // const currentSlot = /(\w+)\/(\w+)$/.exec(compPath)?.[1];
        const currentSlot = pathArr[pathArr.length - 2];
        if (!currentSlot) return;
        if (currentSlot) {
          const indexAtSibling = slotSiblings.indexOf(currentSlot);
          if (!~indexAtSibling) return;
          if (indexAtSibling === 0) {
            selectParentPrev();
          } else {
            this.activeCompPath = `${pathArr.slice(0, len - 2).join('/')}/${slotSiblings[indexAtSibling - 1]}/0`;
          }
        }
        return;
      }
      selectParentPrev();
    } else {
      const newCompPath = `${pathArr.slice(0, len - 1).join('/')}/${+index - 1}`;
      this.activeCompPath = newCompPath;
      // 上快捷键选中的是深层展开的节点
      // 要深层次的递归，每次都需要nexttick，因为layout是根据path watch出来的
      let iterPath = newCompPath;
      while (iterPath && this.expandedLUT[iterPath]) {
        // eslint-disable-next-line no-loop-func
        await this.$nextTick(() => {
          iterPath = this.selectLastChild();
        });
      }
    }
  }
  selectParent() {
    const {
      compPath
    } = this.bus.activeCompInfo;
    if (!compPath) return;
    const pathArr = compPath.split('/');
    const len = pathArr.length;
    const newCompPath = `${pathArr.slice(0, len - 2).join('/')}`;
    this.activeCompPath = newCompPath;
  }
  selectLastChild() {
    var _layout$children, _layout$children2;
    const {
      compPath,
      layout
    } = this.bus.activeCompInfo;
    if (!((_layout$children = layout.children) !== null && _layout$children !== void 0 && _layout$children.length) && !Object.keys(layout.slots || {}).length) {
      var _this$activeLayout;
      if (Object.keys(((_this$activeLayout = this.activeLayout) === null || _this$activeLayout === void 0 ? void 0 : _this$activeLayout.scopedSlots) || {}).length > 0) {
        return;
      }
      return;
    }
    let path;
    if ((_layout$children2 = layout.children) !== null && _layout$children2 !== void 0 && _layout$children2.length) {
      path = `${compPath}/default/${layout.children.length - 1}`;
      this.activeCompPath = path;
    } else {
      const keys = Object.keys(layout.slots);
      const key = keys[keys.length - 1];
      path = `${compPath}/${key}/0`;
      this.activeCompPath = compPath;
    }
    return path;
  }
  selectChild() {
    var _layout$children3;
    const {
      compPath,
      layout
    } = this.bus.activeCompInfo;
    if (!((_layout$children3 = layout.children) !== null && _layout$children3 !== void 0 && _layout$children3.length) && !Object.keys(layout.slots || {}).length) {
      this.selectNext();
      return;
    }
    // 在domtree中约定，渲染循序: scopedSlots > slots > children
    // scopedSlots是无法被直接选中的，需要点击
    if (Object.keys(layout.slots || {}).length) {
      const key = Object.keys(layout.slots)[0];
      this.activeCompPath = `${compPath}/${key}/0`;
    } else {
      this.activeCompPath = `${compPath}/default/0`;
    }
  }
  selectNext() {
    const {
      compPath
    } = this.bus.activeCompInfo;
    const pathArr = compPath.split('/');
    const len = pathArr.length;
    if (len <= 1) return;
    const index = pathArr[len - 1];
    const selectParentNext = () => {
      const newCompPath = `${pathArr.slice(0, len - 2).join('/')}`;
      if (!newCompPath) return;
      this.activeCompPath = newCompPath;
      this.$nextTick(() => {
        this.selectNext();
      });
    };
    if (index === `${this.bus.activeCompInfo.siblingsNum - 1}`) {
      // slot的情况
      const {
        slotSiblings
      } = this.bus.activeCompInfo;
      if (slotSiblings.length) {
        // const currentSlot = /(\w+)\/(\w+)$/.exec(compPath)?.[1];
        const currentSlot = pathArr[pathArr.length - 2];
        if (!currentSlot) return;
        if (currentSlot) {
          const indexAtSibling = slotSiblings.indexOf(currentSlot);
          if (!~indexAtSibling) return;
          if (indexAtSibling === slotSiblings.length - 1) {
            selectParentNext();
          } else {
            const newCompPath = `${pathArr.slice(0, len - 2).join('/')}/${slotSiblings[indexAtSibling + 1]}/0`;
            this.activeCompPath = newCompPath;
          }
        }
        return;
      }
      selectParentNext();
    } else {
      const newCompPath = `${pathArr.slice(0, len - 1).join('/')}/${+index + 1}`;
      this.activeCompPath = newCompPath;
    }
  }
  selectNextCandidate() {
    if (!this.candidateCompPaths.length) return;
    let newIndex = this.candidateIndex + 1;
    if (this.candidateIndex === this.candidateCompPaths.length - 1) {
      newIndex = 0;
    }
    const newCompPath = this.candidateCompPaths[newIndex];
    if (typeof newCompPath === 'undefined') return;
    this.candidateIndex = newIndex;
    this.activeCompPath = newCompPath;
  }
  selectPrevCandidate() {
    if (!this.candidateCompPaths.length) return;
    let newIndex = this.candidateIndex - 1;
    if (this.candidateIndex <= 0) {
      newIndex = this.candidateCompPaths.length - 1;
    }
    const newCompPath = this.candidateCompPaths[newIndex];
    if (typeof newCompPath === 'undefined') return;
    this.candidateIndex = newIndex;
    this.activeCompPath = newCompPath;
  }
  switchScope() {
    const {
      list,
      compPath,
      index,
      type
    } = this.currentScope;
    if (list && list.length && list[index]) {
      if (this.isDesignMode && this.designer.scopeStack.length !== this.bus.scopedSlotStack.length) {
        this.designer.enterScopedSlot({
          renderer: list[index],
          compPath,
          slotId: type,
          prevCompPath: compPath
        });
      } else {
        // 在运行模式下的作用域 由ultPagelet来handle
      }
      this.activeCompPath = '';
    }
  }
  setExtensionPanel(k, v) {
    Vue.set(this.bus.extensionPanels, k, v);
  }
  get currentScope() {
    var _this$bus$scopedSlotS, _this$bus$scopedSlotS2;
    return ((_this$bus$scopedSlotS = this.bus.scopedSlotStack) === null || _this$bus$scopedSlotS === void 0 ? void 0 : _this$bus$scopedSlotS[((_this$bus$scopedSlotS2 = this.bus.scopedSlotStack) === null || _this$bus$scopedSlotS2 === void 0 ? void 0 : _this$bus$scopedSlotS2.length) - 1]) || {};
  }
  get devToolTabKey() {
    return this.bus.devToolTabKey;
  }
  set devToolTabKey(val) {
    this.$set(this.bus, 'devToolTabKey', val);
  }
  get designerCompPath() {
    var _this$designer4;
    return (_this$designer4 = this.designer) === null || _this$designer4 === void 0 ? void 0 : _this$designer4.compPath;
  }
  get componentGroups() {
    var _this$designer5;
    return ((_this$designer5 = this.designer) === null || _this$designer5 === void 0 ? void 0 : _this$designer5.getMaterialBoxGroups({
      filter: component => {
        if (!component.visible) return false;
        if (component.type !== 'normal') return false;
        return true;
      }
    })) || [];
  }
  get uc() {
    return this.bus.ucBus;
  }
  set uc(val) {
    this.bus.$set(this.bus, 'ucBus', val);
  }
  get isDesignMode() {
    var _this$uc;
    return !!((_this$uc = this.uc) !== null && _this$uc !== void 0 && _this$uc.designer);
  }
  get defaultProps() {
    var _this$ultMeta;
    return cloneDeep((_this$ultMeta = this.ultMeta) === null || _this$ultMeta === void 0 ? void 0 : _this$ultMeta.defaultProps) || {};
  }
  get ultPagelet() {
    var _this$uc2, _this$uc3;
    if (this.bus.scopedSlotStack.length) {
      var _this$currentScope$li;
      return (_this$currentScope$li = this.currentScope.list[this.currentScope.index]) === null || _this$currentScope$li === void 0 ? void 0 : _this$currentScope$li.ucPagelet;
    }
    return ((_this$uc2 = this.uc) === null || _this$uc2 === void 0 || (_this$uc2 = _this$uc2.designer) === null || _this$uc2 === void 0 ? void 0 : _this$uc2.pagelet) || ((_this$uc3 = this.uc) === null || _this$uc3 === void 0 ? void 0 : _this$uc3.renderer.ucPagelet);
  }
  get ultMeta() {
    var _this$uc4, _this$bus$activeCompI;
    return (_this$uc4 = this.uc) === null || _this$uc4 === void 0 || (_this$uc4 = _this$uc4.components[(_this$bus$activeCompI = this.bus.activeCompInfo.layout) === null || _this$bus$activeCompI === void 0 ? void 0 : _this$bus$activeCompI.type]) === null || _this$uc4 === void 0 ? void 0 : _this$uc4.meta;
  }
  get ultIsContainer() {
    var _this$ultMeta2, _this$ultMeta3, _this$activeLayout$ch, _this$activeLayout2, _this$activeLayout3;
    return ((_this$ultMeta2 = this.ultMeta) === null || _this$ultMeta2 === void 0 ? void 0 : _this$ultMeta2.category) === '容器' || ((_this$ultMeta3 = this.ultMeta) === null || _this$ultMeta3 === void 0 ? void 0 : _this$ultMeta3.category) === '布局' || ((_this$activeLayout$ch = this.activeLayout.children) === null || _this$activeLayout$ch === void 0 ? void 0 : _this$activeLayout$ch.length) > 0 || Object.keys(((_this$activeLayout2 = this.activeLayout) === null || _this$activeLayout2 === void 0 ? void 0 : _this$activeLayout2.scopedSlots) || {}).length > 0 || Object.keys(((_this$activeLayout3 = this.activeLayout) === null || _this$activeLayout3 === void 0 ? void 0 : _this$activeLayout3.slots) || {}).length > 0;
  }
  get designer() {
    var _this$uc5;
    return (_this$uc5 = this.uc) === null || _this$uc5 === void 0 ? void 0 : _this$uc5.designer;
  }
  get bus() {
    return getDtBus();
  }
  // #region layout面板的getter setter
  get dataSourceDrawerOpen() {
    return this.bus.layoutOpts.dataSourceDrawerOpen;
  }
  set dataSourceDrawerOpen(val) {
    this.bus.$set(this.bus.layoutOpts, 'dataSourceDrawerOpen', val);
  }
  get expandedLUT() {
    return this.bus.layoutOpts.expandedLUT;
  }
  get searchInput() {
    return this.bus.layoutOpts.searchInput;
  }
  set searchInput(val) {
    this.bus.$set(this.bus.layoutOpts, 'searchInput', val);
  }
  get searchCandidates() {
    return this.bus.layoutOpts.searchCandidates;
  }
  set searchCandidates(val) {
    this.bus.$set(this.bus.layoutOpts, 'searchCandidates', val);
  }
  get candidateCompPaths() {
    return this.searchCandidates.map(el => el.compPath);
  }
  get candidateIndex() {
    return this.bus.layoutOpts.candidateIndex;
  }
  set candidateIndex(val) {
    this.bus.$set(this.bus.layoutOpts, 'candidateIndex', val);
  }
  // #endregion
  get currentScopedSlotIndex() {
    return this.currentScope.index || 0;
  }
  set currentScopedSlotIndex(val) {
    let ult = val;
    if (ult === this.currentScope.list.length) ult = 0;
    if (ult === -1) ult = this.currentScope.list.length - 1;
    this.$set(this.bus.scopedSlotStack[this.bus.scopedSlotStack.length - 1], 'index', ult);
  }
  get activeCompPath() {
    return this.bus.activeCompInfo.compPath;
  }
  set activeCompPath(val) {
    this.$set(this.bus.activeCompInfo, 'compPath', val);
  }
  get editOption() {
    return this.bus.options.editOption;
  }
  set editOption(val) {
    this.bus.$set(this.bus.options, 'editOption', val);
  }
  get activeLayout() {
    return this.bus.activeCompInfo.layout;
  }
  set activeLayout(val) {
    var _this$designer6;
    (_this$designer6 = this.designer) === null || _this$designer6 === void 0 || _this$designer6.modifyActiveComp(c => {
      this.$set(c, 'props', val.props);
      val.events && this.$set(c, 'events', val.events);
    });
  }
  get windowRef() {
    return this.bus.windowRef;
  }
  set windowRef(val) {
    this.bus.$set(this.bus, 'windowRef', val);
  }
  get activeSourcePath() {
    return compPathToSourcePath(this.activeCompPath).join('/');
  }
  set activeSourcePath(val) {
    this.activeCompPath = sourcePathToCompPath(val.split('/')) || '';
  }
  // #region Timeline
  get events() {
    return this.bus.timelineOpts.events;
  }
  set events(val) {
    this.bus.$set(this.bus.timelineOpts, 'events', val);
  }
  get manualDisable() {
    return this.bus.timelineOpts.manualDisable;
  }
  set manualDisable(val) {
    this.bus.timelineOpts.manualDisable = val;
  }
  get selectedEvents() {
    return this.bus.timelineOpts.selectedEvents;
  }
  set selectedEvents(val) {
    this.bus.timelineOpts.selectedEvents = val;
  }
  get extensionPanels() {
    return this.bus.extensionPanels;
  }
  set extensionPanels(val) {
    this.bus.$set(this.bus, 'extensionPanels', val);
  }
  get displayMode() {
    return this.bus.options.displayMode;
  }
  set displayMode(val) {
    (Object.values(lsKeysForDevTool) || []).forEach(element => {
      localStorage.removeItem(element);
    });
    this.bus.$set(this.bus.options, 'displayMode', val);
  }
  get isXY() {
    var _this$windowRef2, _this$windowRef3;
    return !!window.xy_vue_instance || ((_this$windowRef2 = this.windowRef) === null || _this$windowRef2 === void 0 || (_this$windowRef2 = _this$windowRef2.opener) === null || _this$windowRef2 === void 0 ? void 0 : _this$windowRef2.xy_vue_instance) || ((_this$windowRef3 = this.windowRef) === null || _this$windowRef3 === void 0 || (_this$windowRef3 = _this$windowRef3.top) === null || _this$windowRef3 === void 0 ? void 0 : _this$windowRef3.xy_vue_instance);
  }
  get showJump() {
    var _this$windowRef4, _this$windowRef5;
    return !this.isDesignMode && (window.xy_runtime_project || ((_this$windowRef4 = this.windowRef) === null || _this$windowRef4 === void 0 || (_this$windowRef4 = _this$windowRef4.opener) === null || _this$windowRef4 === void 0 ? void 0 : _this$windowRef4.xy_runtime_project) || ((_this$windowRef5 = this.windowRef) === null || _this$windowRef5 === void 0 || (_this$windowRef5 = _this$windowRef5.top) === null || _this$windowRef5 === void 0 ? void 0 : _this$windowRef5.xy_runtime_project));
  }
  get windowOptions() {
    return this.bus.windowOptions;
  }
  set windowOptions(val) {
    var _this$bus;
    (_this$bus = this.bus) === null || _this$bus === void 0 || _this$bus.$set(this.bus, 'windowOptions', val);
  }
  get container() {
    return this.bus.container;
  }
  set container(val) {
    this.bus.$set(this.bus, 'container', val);
  }
};
devToolMixin = __decorate([Component
// eslint-disable-next-line @typescript-eslint/naming-convention
], devToolMixin);
export default devToolMixin;
//# sourceMappingURL=devToolMixin.js.map
